export const FORM_BLANK = 1;
export const FORM_PSYCHO_QUIZ = 2;
export const SIGNUP_FORM = 3;
export const REDEEM_FORM = 4;
export const FORM_QUIZ = 5;
export const FORM_SURVEY = 6;
// [86entxjdp] 遊戲模組 移除 Form API call (FORM_LOTTERY_GAME = 7)
export const FORM_INVOICE = 8;
export const FORM_VOTE = 9;
